import { FileResponseData } from "./filesTypes";

export enum clientStatus {
  Pending = 0,
  InProcess = 1,
  Accepted = 2,
  Rejected = 3,
}

export interface ClientData {
  id: string;
  name: string;
  passportNumber: string;
  fileEntities?: FileResponseData[];
  bookingCode: string | null;
  status: clientStatus;
  createDate?: string | null;
  updateDate?: string | null;
  birthDate?: string | null;
  issueDate?: string | null;
  expiredDate?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  bookingId: string;
  email?: string | null;
  phone?: string | null;

  touristVisaIssueDate?: string | null; // e.g. ISO date string
  entryDateToUAE?: string | null;       // e.g. ISO date string
  visaExpiryDate?: string | null;
}
